export default {
  shared: {
    document: 'shared/{{ orgOguid }}/{{ docOguid }}/document',
    page: 'shared/{{ orgOguid }}/{{ docOguid }}/document/page/{{ page }}',
    sign: 'shared/{{ orgOguid }}/{{ docOguid }}/document/completeTask'
  }
}
